import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  flex-grow: ", ";\n  flex-shrink: ", ";\n  overflow-y: auto;\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
export var ScrollWrapper = styled.div(_templateObject(), function (_ref) {
  var _ref$grow = _ref.grow,
      grow = _ref$grow === void 0 ? true : _ref$grow;
  return grow ? 1 : 0;
}, function (_ref2) {
  var _ref2$shrink = _ref2.shrink,
      shrink = _ref2$shrink === void 0 ? true : _ref2$shrink;
  return shrink ? 1 : 0;
});